import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const selectPdfBuilder = (state: RootState) => state.pdfBuilder;

export const selectPdfBuilderGeneratedReports = createSelector(
  [selectPdfBuilder],
  ({ generatedReports, generatedReportsRequestId, generatedReportsTotal }) => ({
    generatedReports,
    loadingGeneratedReports: !!generatedReportsRequestId,
    generatedReportsTotal,
  }),
);

export const selectPdfBuilderScheduledReports = createSelector(
  [selectPdfBuilder],
  ({ scheduledReports, scheduledReportsRequestId, scheduledReportsTotal }) => ({
    scheduledReports,
    loadingScheduledReports: !!scheduledReportsRequestId,
    scheduledReportsTotal,
  }),
);
